// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const initialFormValues = Object.freeze({
  billcode: '',
  companyName: '',
  serviceContactCode: '',
  contactName: '',
  companyFrn: '',
  email: '',
})

export default initialFormValues
